import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { ITeamFileDeleteFileFormFormProps } from './types';
import { IMeetingSimple } from '../../../../../app/resource/meeting-simple/meeting-simple.types';
import { useParams } from 'react-router-dom';
import { useSelectWithParams } from '../../../../../utils/selector.utils';
import { dialogSelectors } from '../../../../../app/dialog/dialog.selectors';
import { teamFilesDeleteFilelMeetingDashboardPage } from '../../../../../app/page/meeting-dashboard/meeting-dashboard.actions';

export const MeetingShortcutDeleteFileForm: FunctionComponent = () => {
  const { meetingId } = useParams<{ meetingId: IMeetingSimple['id'] }>();

  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'meetingShortcutDeleteFileDialog',
  ) as ITeamFileDeleteFileFormFormProps;

  const dispatch = useDispatch();

  const formProps = useForm();
  const onSubmit = () => {
    dispatch(teamFilesDeleteFilelMeetingDashboardPage(meetingId, props.folderFileId));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="team-files-delete-file-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit(() => onSubmit())}
        method="post"
      >
        <div className="field-container" style={{ textAlign: 'center' }}>
          <span>Are you sure you want to delete this file?</span>
        </div>
      </form>
    </FormProvider>
  );
};
